import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import PublicIcon from '@mui/icons-material/Public';
import Link from '@mui/material/Link';
import EntitySidebar from 'components/EntitySidebar';
import SidebarBox from 'components/SidebarBox';

import { PUBLIC_URL } from 'const';
import { WhatToSeeSidebar_whatToSee$key } from '__generated__/WhatToSeeSidebar_whatToSee.graphql';

type Props = {
  whatToSee: WhatToSeeSidebar_whatToSee$key;
};

const WhatToSeeSidebar: FC<Props> = props => {
  const whatToSee = useFragment(
    graphql`
      fragment WhatToSeeSidebar_whatToSee on WhatToSee {
        seo {
          slug
        }

        ...EntitySidebar_entity
      }
    `,
    props.whatToSee
  );

  return (
    <EntitySidebar entity={whatToSee}>
      <SidebarBox icon={PublicIcon}>
        <Link
          href={`${PUBLIC_URL}/ka-pamatyti/${whatToSee.seo.slug}`}
          target="_blank">
          Puslapis svetainėje
        </Link>
      </SidebarBox>
    </EntitySidebar>
  );
};

export default WhatToSeeSidebar;
